import React from 'react';
import classNames from 'classnames';

import CheckmarkIcon from '../cart/Icons/CheckmarkIcon';

type Props = {
	isSelected: boolean;
	isCompleted: boolean;
	isFinalStep: boolean;
	isAllCompleted: boolean;
	label?: string;
	step?: number;
	onClick?: () => void | null;
};

const DivOrButton = ({ onClick, ...props }) => {
	if (onClick) {
		return <button type="button" onClick={onClick} {...props} />;
	}
	return <div {...props} />;
};

const ProgressBarStep = React.forwardRef(
	(
		{ isSelected, isCompleted, isFinalStep, isAllCompleted, label, step, onClick }: Props,
		ref: React.LegacyRef<HTMLDivElement>
	) => {
		const progressBarStepClassName = classNames('progress-bar-step ty-c3', {
			'progress-bar-step--is-selected': isSelected,
			'progress-bar-step--is-completed': isCompleted,
			'progress-bar-step--is-all-completed': isAllCompleted && !isFinalStep,
			'progress-bar-step--is-all-completed-final': isAllCompleted && isFinalStep,
		});

		return (
			<DivOrButton
				className={progressBarStepClassName}
				onClick={!isAllCompleted ? onClick : undefined}
			>
				<div className="progress-bar-step__num progress-bar-step__checkmark-icon ty-c3" ref={ref}>
					{isCompleted ? <CheckmarkIcon /> : step}
				</div>

				{label && <div className="progress-bar-step__text">{label}</div>}
			</DivOrButton>
		);
	}
);

export default ProgressBarStep;
